import { create } from 'zustand';
import {
    WorkflowTruckI,
    WorkflowTruckActionI,
    WorkflowI,
    WorkflowActionI,
} from '../../../libs/interfaces';
import { createWorkflowTruckSlice } from './workflow-truck.store';
import { persist } from 'zustand/middleware';
import { createWorkflowSlice } from './workflow.store';
// import { unifiedZustandStorage } from '../../../libs/helpers';
// const storage = unifiedZustandStorage;
// Custom storage object

export const useWorkflowTruckStore = create<WorkflowTruckI &
    WorkflowTruckActionI & WorkflowI & WorkflowActionI>()(
        persist(
            (...a) => ({
                ...createWorkflowSlice(...a),
                ...createWorkflowTruckSlice(...a),
            }), {
            name: 'workflow-truck-puce-0',
        }))
